<template>
  <div class="menubar">
    <b-navbar type="dark" variant="dark">
      <b-navbar-brand href="#" @click="toMain">LogCrow</b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="user" href="#" @click="toNew">New</b-nav-item>
        <b-nav-item v-if="user" href="#" @click="toMyLogs">MyLogs</b-nav-item>
        <b-nav-item v-if="user" href="#" @click="toMyFavorites">MyFavorites</b-nav-item>
        <b-nav-item v-if="user" href="#" @click="toAnalyze">Analyze</b-nav-item>
        <div v-if="user">
          <b-nav-item-dropdown no-caret right>
            <template v-slot:button-content>
              <v-gravatar class="gravatar" :email="user.email" :size=24 />
            </template>
            <b-dropdown-item href="#" @click="$bvModal.show('changePassword')">Change password</b-dropdown-item>
            <b-dropdown-item href="#" @click="signOut">Sign out</b-dropdown-item>
          </b-nav-item-dropdown>
        </div>
        <div class="signoutbar" v-else>
          <b-nav-item @click="toSignup">Sign up</b-nav-item>
          <b-nav-item @click="toSignin">Sign in</b-nav-item>
        </div>
      </b-navbar-nav>
    </b-navbar>
    <b-modal
      id="changePassword"
      title="Change your password"
      ok-title="Change password"
      @ok="sendChange"
      @cancel="clearPassword"
      @close="clearPassword"
      @hidden="clearPassword"
    >
      <h6>Please input new password.</h6>
      <b-input-group>
        <b-form-input
          id="password-input"
          :type="fieldType"
          v-model="password"
          required
        ></b-form-input>
        <b-input-group-append>
          <b-button v-on:mousedown="viewPassword" v-on:touchstart="viewPassword" v-on:touchend="hiddenPassword" v-on:mouseup="hiddenPassword">
            <font-awesome-icon v-if="fieldType === 'password'" :icon="['fas','eye']" size="s" />
            <font-awesome-icon v-if="fieldType === 'text'" :icon="['fas','eye-slash']" size="s" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Menubar',
  props: {},
  data () {
    return {
      fieldType: 'password',
      password: ''
    }
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    signOut: function () {
      firebase.auth().signOut().then(() => {
        this.$store.commit('setUser', null)
        this.$store.commit('setLogs', [])
        this.$router.push('/')
      })
    },
    toNew: function () {
      this.$router.push('/new')
    },
    toSignup: function () {
      this.$router.push('/signup')
    },
    toSignin: function () {
      this.$router.push('/signin')
    },
    toMain: function () {
      this.$router.push('/')
    },
    toMyLogs: function () {
      this.$router.push('/mylogs')
    },
    toMyFavorites: function () {
      this.$router.push('/myfavorites')
    },
    toAnalyze: function () {
      this.$router.push('/upload')
    },
    viewPassword: function () {
      this.fieldType = 'text'
    },
    hiddenPassword: function () {
      this.fieldType = 'password'
    },
    sendChange: function () {
      let user = firebase.auth().currentUser
      if (user) {
        user.updatePassword(this.password).then(() => {
          this.makeToast('success', 'Updated your password.')
        }).catch(() => {
          this.makeToast('warning', 'Failed to update password.')
        })
      } else {
        this.makeToast('warning', 'Failed to update password.')
      }
    },
    clearPassword: function () {
      this.password = ''
    }
  },
  computed: {
    user(){
      return this.$store.getters.user
    }
  },
}
</script>

<style>
.gravatar{
  border-radius: 50%;
}
.signoutbar {
  display: inherit;
}
</style>
